import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import {
    mimeTypeMap, 
    MyDate
} from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
//--------------------------------------------------------------------------------------------
export default function Export({
    filterWorkInstructions
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
        if(!filterWorkInstructions.length){
            window.alert("No data to export.");
            return;
        }
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = filterWorkInstructions.map(post => [
            post.allDay,
            post.billed, 
            post.fieldSupervisorEmail,
            post.fieldSupervisorName,
            {formula: `=HYPERLINK("http://google.com/maps?q=${post.coords}", "${post.location.replace(/'/g, "\\'").replace(/"/g, "\\\"")}")`},
            post.supervisor,
            post.teamLeadName,
            post.startTime,
            post.endTime,
            post.workHours,
            post.travelHours,
            post.totalHours,
            post.laborHoursDetail.map(p => ` • ${p[0]} - ${p[1]} - ${p[2]} -  ${p[3]}`).join("\n"),
            post.workInstructionDescription, /* html */
            post.creator,
            post.workInstructionCreationDate?new Date(post.workInstructionCreationDate?.replace(/-/g, "/")):"", 
            post.updater,
            post.workInstructionDateUpdated?new Date(post.workInstructionDateUpdated?.replace(/-/g, "/")):"", 
        ])
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            totalsRow: true,
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "All Day", filterButton: true},
                { name: "Billed", filterButton: true},
                { name: "Field Supervisor Email", filterButton: true},
                { name: "Field Supervisor Name", filterButton: true},
                { name: "Location", filterButton: true},
                { name: "Supervisor", filterButton: true}, 
                { name: "Team Lead", filterButton: true},
                { name: "Start Time", filterButton: true},
                { name: "End Time", filterButton: true},
                { name: "Work Hours", filterButton: true},
                { name: "Travel Hours", filterButton: true},
                { name: "Total Hours", filterButton: true},
                { name: "Hours Detail", filterButton: true},
                { name: "Work Instruction Description", filterButton: true},
                { name: "Creator", filterButton: true},
                { name: "Work Instruction Creation Date", filterButton: true},
                { name: "Updater", filterButton: true},
                { name: "Work Instruction Date Updated", filterButton: true},
            ],
            rows: rows,
        });
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                /* exclude row 1 */
                if(cell.row === 1) return;
                //-------------------------
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        worksheet.getRows(2, rows.length).forEach(row => {row.alignment = { vertical: "middle", horizontal: "center", wrapText: true }});
        worksheet.getColumn(16,/*#*/).alignment = {"wrapText": true, vertical: "top", horizontal: "left"};
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `work instructions export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return(
        <span className = "pointer" onClick = {exportFunc}>
            Export
        </span>
    )
};